var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{attrs:{"label":_vm.$vuetify.lang.t('$vuetify.keep_menu_expanded'),"color":"primary"},on:{"change":_vm.toggleMenuPersistence},model:{value:(_vm.keepMenuExpanded),callback:function ($$v) {_vm.keepMenuExpanded=$$v},expression:"keepMenuExpanded"}})
}
var staticRenderFns = []

export { render, staticRenderFns }